// Where a photo was taken, for the site plan's pins (docs/CONDITION-REPORTS.md
// "Same-view photos": outdoors ±2–5 m, indoors only the room). The position
// is watched in the background wherever photos are taken, and a photo takes
// the latest one — so taking a photo never waits for GPS.
//
// Every photo gets it, measuring included, so a condition report started
// later can still pin the photos (DD, 2026-10-21). The iPad asks for location
// once. Permission refused, or no fix yet: photos have no position.

export interface Position {
  latitude: number;
  longitude: number;
  /** Metres, as the device reports it. */
  accuracy: number;
}

/** A fix older than this is stale (indoors, or the device stopped reporting). */
const FRESH_MS = 60_000;

let latest: (Position & { at: number }) | null = null;
let watchId: number | null = null;

/** Start watching the position (asks for permission the first time). Safe to call repeatedly. */
export function armLocation(): void {
  if (watchId !== null || typeof navigator === 'undefined' || !navigator.geolocation) return;
  watchId = navigator.geolocation.watchPosition(
    (fix) => {
      latest = { latitude: fix.coords.latitude, longitude: fix.coords.longitude, accuracy: fix.coords.accuracy, at: Date.now() };
    },
    // Refused or unavailable: photos go without a position; nothing to show.
    () => undefined,
    { enableHighAccuracy: true, maximumAge: 10_000 },
  );
}

/** The position for a photo just taken, or null if there's no recent fix. */
export function positionNow(): Position | null {
  if (!latest || Date.now() - latest.at > FRESH_MS) return null;
  const { latitude, longitude, accuracy } = latest;
  return { latitude, longitude, accuracy };
}
